export default __webpack_public_path__ + "locales/az/PortalUnavailable.json?hash=a90e23dce7d318691f2483189e7574fd";